export default "__VITE_ASSET__BMxwf19J__"